<template>
  <div class="detail" v-loading.fullscreen.lock="planRemarkSaving">
    <detailHeader />
    <!-- 列表 -->
    <div class="inspectDetail">
      <div class="inspectActions">
        <!-- 开始核查 -->
        <el-button type="success" size="small" @click="startChecking" v-if="!isChecking && isAuth(183)">
          {{ $t("message.startChecking") }}</el-button>
        <!-- 核查中 -->
        <el-button type="primary" size="small" v-if="isChecking">
          {{ $t("message.underCheck") }}</el-button>
        <el-button type="primary" size="small" @click="upPreview" v-if="isChecking">
          刷新</el-button>
        <b v-if="authorized" class="authorized"> [授权客户] </b>
        <el-button v-if="materialRows.length" class="materialBatchToggle" size="small" @click="toggleAllMaterials">
          {{ allMaterialsExpanded ? $t('message.materialCollapseAll') : $t('message.materialExpandAll') }}
        </el-button>
      </div>
      <div class="table">
        <ol>
          <!-- 选择 -->
          <li class="flex05">{{ $t("message.choose") }}</li>
          <!-- 番号 -->
          <li class="flex05">{{ $t('message.mash') }}</li>
          <!--  店铺信息-->
          <li class="flex15">
            {{ $t("message.storeInformation") }}
          </li>
          <!-- 照片-->
          <li>
            {{ $t("message.pic") }}
          </li>
          <!--链接  -->
          <li>{{ $t("message.link") }}</li>
          <!-- 业务编辑商品属性 -->
          <li class="flex2">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
          <!--OPTION  -->
          <li class="flex2">OPTION</li>
          <!--交易号数量  -->
          <li>{{ $t("message.numberOfTransactionNumbers") }}</li>
          <!-- 本次到货数 -->
          <li>{{ $t("message.numberOfArrivalsThisTime") }}</li>
          <!--已加检品单数  -->
          <li>{{ $t("message.theNumberOfItemsThatHaveBeenInspected") }}</li>
          <!-- 价格 -->
          <li>{{ $t("message.price") }}</li>
          <!-- 检品问题数 -->
          <li>{{ $t("message.numberOfInspectionProblems") }}</li>
          <!-- 问题产品数 -->
          <li>{{ $t("message.numberOfProblemProducts") }}</li>
          <!--状态 -->
          <li>{{ $t("message.status") }}</li>
          <!-- 担当备注 -->
          <li class="flex15">
            {{ $t("message.responsibleForRemarks") }}
          </li>
          <!-- 采购备注 -->
          <li class="flex15">
            {{ $t("message.purchasingNotes") }}
          </li>
          <!-- 核查员备注 -->
          <li class="flex15">
            {{ $t("message.verifierSNotes") }}
          </li>
          <!-- 操作 -->
          <li>{{ $t("message.operation") }}</li>
        </ol>
        <!-- 无数据显示 -->
        <div class="noData" v-if="tableData == false">暂无数据</div>
        <!-- 订单详情 -->
        <div class="itemDetail" v-for="(item, index) in tableData" :key="index">
          <div class="head">
            <div class="checkbox">
              <label>
                <el-checkbox v-model="item.checked" @change="changeOrder" :disabled="!isChecking"></el-checkbox>
              </label>
            </div>
            <!-- 是否显示 -->
            <div class="show" @click="isShow(index)">
              <i class="el-icon-arrow-down" v-if="!item.show"></i>
              <i class="el-icon-arrow-up" v-else></i>
            </div>
            <!--  付款时间 -->
            <div class="item time">
              <p>{{ $t("message.customerPaymentTime") }}</p>
              <p>
                {{ item.datetime_pay_confirm }}
              </p>
            </div>
            <!-- 订单号 -->
            <div class="item order" style="padding: 2px 10px;">
              <div>
                <b style="color: #2C96E7;"> {{ item.user.authorized == 1 ? '[授权]' : '' }} </b>
                <router-link :to="'orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                  {{ item.order_sn }}
                </router-link>

                <div style="display: inline-block; width: 100px;vertical-align: middle;">
                  <attributeName :name="item.order_attribute" />
                </div>
                <i class="el-icon-copy-document" @click="copy(item.order_sn)"></i>
              </div>
              <div class="bigSize" style="font-weight: bold;">
                {{ item.user.realname }}
                <div style="display: inline-block; width: 100px;vertical-align: middle;">
                  <attributeName :name="item.user_attribute" />
                </div>
              </div>
            </div>
            <!-- 交易号  -->
            <div class="item flex15" style="line-height: 20px">
              <span>
                {{ $t("message.transactionNumber") }}：
                <a href="javascript:;" class="a-link">
                  {{ item.purchase_no }}</a>
                <i class="el-icon-copy-document" @click="copy(item.purchase_no)"></i>
              </span>
              <!-- 物流号 -->
              <p>
                {{ $t("message.logisticsNumber") }}：
                <a href="javascript:;" class="a-link">
                  {{
                    item.order_purchase_express != false
                      ? item.order_purchase_express[0].express_no
                      : "-"
                  }}
                  <i class="el-icon-copy-document" @click="copy(item.order_purchase_express[0].express_no)"
                    v-if="item.order_purchase_express != false"></i>
                  <el-tooltip placement="top" v-if="item.order_purchase_express != false">
                    <div slot="content">
                      <p v-for="(items, indexs) in item.order_purchase_express" :key="indexs">
                        {{ $t("message.logisticsNumber") }}{{ indexs + 1 }}：
                        {{ items.express_no }}
                      </p>
                    </div>
                    <el-button size="mini" type="primary" icon="el-icon-search"
                      class="express_no-list primary"></el-button>
                  </el-tooltip>
                </a>

              </p>
            </div>
            <div class="item name">
              <!-- 业务 -->
              <span>{{ $t("message.business") }}：{{ item.y_name }}</span>
              <!--  采购-->
              <span>{{ $t("message.purchase") }}：{{ item.g_name }}</span>
              <!-- 配货 -->
              <span>{{ $t("message.distribution") }}：{{ item.p_name }}</span>
            </div>
            <!-- 查看备注 -->
            <div class="lookRemark item">
              <!-- 入库唛头打印 -->
              <el-button type="success" size="small" class="primary" :disabled="!isChecking"
                @click="printUpStorageEntryLabel(item)">
                入库唛头打印</el-button>
              <!-- 打印包裹信息 -->
              <el-button type="success" size="small" class="primary" :disabled="!isChecking"
                @click="printPackageInformation(item)">
                {{ $t("message.printPackageInformation") }}</el-button>
              <!-- 打印客户信息 -->
              <el-button type="success" size="small" class="primary" :disabled="!isChecking"
                @click="printCustomerInformation(item)">
                {{ $t("message.printCustomerInformation") }}</el-button>
              <el-button type="primary" @click="lookRemark(item)" style="background: #fa5058" size="small"
                :disabled="!isChecking">
                RK{{ $t("message.orderNotes") }}</el-button>

            </div>
          </div>
          <!--  -->
          <div v-for="(items, indexs) in item.list" :key="items.order_purchase_id || indexs"
            v-show="!item.show" class="inspectGoodsGroup">
          <ul :style="{ background: items.uncomplete_problem_num > 0 ? '#da9396' : '' }">
            <!-- 选择：复选框在上，展开按钮固定最左下方 -->
            <li class="flex05 selectCell">
              <div>
                <el-checkbox v-model="items.checked" @change="changeItem" :disabled="!isChecking"></el-checkbox>
                <!-- 抽查详细 -->
                <spotCheckDetails v-if="items.spotDetail" :spotDetail="items.spotDetail" />
              </div>
           
            </li>
            <li class="flex05">
              <div v-if="isMaterial(items)" class="materialMarkTip" @click.stop>
                <MaterialMarkTip :material-id="items.material_id || (items.material && items.material.id)"
                  :user-id="item.user.id" :detail="items.material || {}" />
              </div>
              {{ items.sorting }}
              <!-- 
              <router-link :to="'/pre-saleProblem?order_sn=' + item.order_sn" class="isWen"
                v-show="items.uncomplete_problem_num" target="_blank">
                问
              </router-link> -->
              <el-popover placement="top-end" width="350" trigger="hover">
                <div v-for="(problem_goods) in items.problem_goods">
                  <p>问题提出时间：{{ problem_goods.created_at }}</p>
                  <p>问题类别：{{ problem_goods.type_name }}</p>
                  <p>具体问题描述：{{ problem_goods.description }}</p>
                </div>
                <router-link
                  :to="'/pre-saleProblem?order_sn=' + item.order_sn + '&status=' + items.problem_goods[items.problem_goods.length - 1].status"
                  target="_blank" v-if="items.problem_goods != false && items.problem_goods != null" slot="reference">问
                </router-link>
              </el-popover>
              <!-- 无论是否绑定辅料，都允许展开查看配货要求。 -->
              <el-button class="materialToggle" type="text" size="mini"
                @click.stop="toggleMaterial(items)">
                {{ items.materialExpanded ? $t("message.collapse") : $t("message.expand") }}
                <i :class="items.materialExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </el-button>
            </li>
            <!--  店铺信息-->
            <li class="flex15">
              <div>
                <p>{{ items.shop_name }}</p>
                <p>{{ items.from_platform }}</p>
                <p>{{ items.shop_id }}</p>
              </div>
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="items.origin_link" target="_blank" slot="reference">
                      <img :src="items.pic" alt="" />
                    </a>
                  </el-popover>
                  <div class="contraband" v-if="items.forbid_goods != false">
                    <el-popover placement="right" width="200" trigger="hover">
                      <div>
                        {{ items.forbid_goods.type_name }}
                      </div>
                      <img src="@/assets/img/contraband1.png" alt="" slot="reference"
                        v-if="items.forbid_goods.status == 3">
                      <img src="@/assets/img/contraband.png" alt="" slot="reference" v-else>
                    </el-popover>
                  </div>
                </div>
              </div>
            </li>
            <!--链接  -->
            <li>
              <el-button size="mini" type="success" :disabled="!isChecking">
                {{ $t("message.copy") }}
              </el-button>
            </li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">
              <div class="template bigSize">
                <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                  <span>{{ skuItem.key }}:</span>
                  <span>{{ skuItem.value }}</span>
                </p>
                <!-- 待补充重量尺寸 -->
                <p v-if="items.record_dimension_tasks != false">
                  <el-tag size="mini" type="primary" effect="dark" class="primary"
                    v-if="items.record_dimension_tasks[0].status == 0">待补充重量尺寸</el-tag>
                </p>
                <!-- 待补充重量尺寸 -->
                <p v-if="items.record_duration_tasks != false">
                  <el-tag size="mini" type="primary" effect="dark" `
                    v-if="items.record_duration_tasks[0].status == 0">待业务录入时效</el-tag>
                </p>
              </div>
            </li>

            <!--OPTION  -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 100px">
                    <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                      <p style="color: rgb(44, 150, 231);">
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 交易号数量  -->
            <li>
              <div class="template" @dblclick="stockListCharge(items.order_purchase_id)">
                <!-- 可入库 -->
                <p>
                  {{ $t("message.canBePutIntoStorage") }}:{{
                    items.possible_num
                  }}
                </p>
                <!-- 已到货 -->
                <p>{{ $t("message.itHasArrived") }}:{{ items.storage_num }}</p>
                <!-- 在库 -->
                <p>{{ $t("message.inStock") }}:{{ items.stock_num }}
                </p>
              </div>
            </li>
            <!-- 本次到货数 -->
            <li>
              <el-input v-model="items.maxUpNum" @input="minMaxNum(index, indexs, items)" type="number"
                onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" :disabled="!isChecking"
                onfocus="this.select()"></el-input>
            </li>
            <!--已加检品单数  -->
            <li :class="{ inspectNum: items.inspectNum > 0 }">{{ items.inspectNum }}</li>
            <!-- 价格 -->
            <li>{{ items.confirm_price }}</li>
            <!-- 检品问题数 -->
            <li>
              <div class="template">
                <!--  数量差 -->
                <p>
                  {{ $t("message.poorQuantity") }}:{{ items.inspect_num_diff }}
                </p>
                <!--  不良数 -->
                <p>{{ $t("message.adverseNumber") }}:
                  <span :class="{ inspectNum: items.inspect_bad_num > 0 }">{{
                    items.inspect_bad_num }}</span>
                </p>
              </div>
            </li>
            <!-- 问题产品数 -->
            <li>
              <span>{{ items.uncomplete_problem_num }}</span>
            </li>
            <!--状态 -->
            <li>
              <div class="inspectStatusCell">
                <span class="inspect_status" @click="lookInspect(items)">{{ items.inspect_status }}</span>
                <div v-if="items.stock_grids && items.stock_grids.length" class="stockGridList">
                  <p v-for="(stockGrid, stockGridIndex) in items.stock_grids" :key="stockGridIndex">
                    {{ getStockGridNumber(stockGrid.grid_number) }} ({{ stockGrid.num }})
                  </p>
                </div>
              </div>
            </li>
            <!-- 担当备注 -->
            <li class="flex15 y_remark">
              <el-input type="textarea" v-model="items.y_remark"
                @blur="updateOrderDetailRemark(items, items.y_remark, 'Y')" :disabled="userRoleStatus != 1"></el-input>
            </li>
            <!-- 采购商品备注 -->
            <li class="flex15">
              <el-input type="textarea" v-model="items.g_remark"
                @blur="updateOrderDetailRemark(items, items.g_remark, 'G')" :disabled="userRoleStatus != 2"></el-input>
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              <el-input type="textarea" v-model="items.p_remark"
                @blur="updateOrderDetailRemark(items, items.p_remark, 'P')" :disabled="userRoleStatus != 5"></el-input>
            </li>
            <!-- 操作 -->
            <li class="fixedRight">
              <div class="Controls">
                <!-- 商品备注 -->
                <p>
                  <el-button style="width: 80px" type="success" size="small" @click="remarkAll(items, index, indexs)"
                    :disabled="!isChecking">
                    {{ $t("message.commodityNote") }}
                  </el-button>
                </p>
                <!-- 纯文字标 -->
                <p>
                  <el-button style="width: 80px" type="success" size="small" @click="printTag(items, 'hide')"
                    :disabled="!isChecking" class="primary">
                    {{ $t("message.plainTextLabel") }}
                  </el-button>
                </p>
                <!-- 文本标 -->
                <p>
                  <el-button style="width: 80px" type="success" size="small" @click="printTag(items, '')"
                    :disabled="!isChecking" class="primary">{{ $t("message.textLabel") }}
                  </el-button>
                </p>
                <!-- 唛头打印 -->
                <p>
                  <el-button style="width: 80px" type="success" size="small" @click="labelPrinting(item, items)"
                    :disabled="!isChecking" class="primary">
                    {{ $t("message.labelPrinting") }}
                  </el-button>
                </p>
                <!-- 特殊打印 12911专享-->
                <p v-if="[326314, 328553, 328554, 328555, 12911].includes(item.user.id)"> <el-button style="width: 80px"
                    type="success" size="small" @click="specialLabelPrinting(items, '')" :disabled="!isChecking"
                    class="primary">
                    {{ $t("message.specialLabelPrinting") }}
                  </el-button>
                </p>
                <!-- 1868标签打印送检唛头 -->
                <p v-if="[1868].includes(item.user.id)">
                  <el-button style="width: 80px" type="success" size="small"
                    @click="label1868Print(item, items, 'inspection')" :disabled="!isChecking" class="primary">
                    送检唛头
                  </el-button>
                </p>
                <!-- 上架唛头 -->
                <p v-if="[1868].includes(item.user.id)">
                  <el-button style="width: 80px" type="success" size="small"
                    @click="label1868Print(item, items, 'putOnShelves')" :disabled="!isChecking" class="primary">
                    上架唛头
                  </el-button>
                </p>
                <!--  退货唛头 -->
                <p v-if="[1868].includes(item.user.id)">
                  <el-button style="width: 80px" type="success" size="small"
                    @click="label1868Print(item, items, 'returnLabel')" :disabled="!isChecking" class="primary">
                    退货唛头
                  </el-button>
                </p>
                <!-- 打标 -->
                <p style="margin-top: 10px;" v-if="[12911].includes(item.user.id)">
                  <el-button type="primary" size="small" @click="labeling(items)"
                    :disabled="!isChecking">12911标</el-button>
                </p>
                <!-- 唐吉唛头打印 -->
                <p v-if="[329990, 331032].includes(item.user.id)" style="margin-bottom: 10px;">
                  <el-button size="small" type="primary" class="primary"
                    @click="TJKDprintLabel(item, 'pint7x4positive')">7*4正面</el-button>
                </p>
                <p class="row" style="margin-bottom: 10px;" v-if="[329990, 331032].includes(item.user.id)">
                  <el-button size="small" type="primary" class="primary"
                    @click="TJKDprintLabel(item, 'print7x4reverse')">7*4背面</el-button>
                </p>
                <p class="row" v-if="[329990, 331032].includes(item.user.id)">
                  <el-button size="small" type="primary" class="primary"
                    @click="TJKDprintLabel(item, 'pint9x95positive')">9*9.5正面</el-button>
                </p>
                <!-- <p class="row">
                  <el-button style="width: 80px" type="success" size="small"
                    @click="checkPutOnShelvesPrint(item, items)" :disabled="!isChecking" class="primary">
                    上架唛头打印
                  </el-button>
                </p> -->
              </div>
            </li>
          </ul>
          <!-- 核查详情左侧辅料只读，右侧配货要求仅业务可编辑。 -->
          <div v-show="items.materialExpanded" class="materialRequirements">
            <div class="materialRequirementsList">
              <MaterialInfo :list="items.material_list" :order-quantity="items.possible_num"
                :user-id="item.user.id" :editable="false" :removable="false" />
            </div>
            <div class="materialRequirementsRemark">
              <div class="requirementItem">
                <label>{{ $t('message.productV2AllocationRequirement') }}</label>
                <el-input v-model="items.delivery_remark" type="textarea" :rows="4" resize="none"
                  :readonly="!isBusiness" @blur="savePlanRemark(items, 'delivery_remark')" />
              </div>
            </div>
          </div>
          </div>
          <!-- 备注 -->
          <div class="order_remark">
            <span>
              {{ $t('message.remark') }}:
            </span>
            <el-input v-model="item.order_remark.y_remark" readonly type="textarea"></el-input>
          </div>
        </div>
      </div>
      <!-- 统计数量 -->
      <div class="total">
        <!-- 总采购数 -->
        <span>总采购数：{{ total.possible_num }}</span>
        <!-- 总到货数 -->
        <span>总到货数：{{ total.storage_num }}</span>
        <!-- 总到货数 -->
        <span>总出货数：{{ total.totalPorderNum ? total.totalPorderNum : 0 }}</span>
      </div>
      <!-- 添加检品单 -->
      <div class="addInspect" v-if="isChecking">
        <!-- 添加普检单 -->
        <div class="list">
          <div class="type">
            <el-button type="primary" size="small" class="primary" @click="inspectStore(1)" v-if="isAuth(194)">
              {{ $t("message.addTheGeneralInspectionList") }}
            </el-button>
          </div>
          <div class="items">
            <div class="item" v-for="item in P_list" :key="item.inspect_sn">
              <div class="item-box">
                <el-radio v-model="radio" :label="item.inspect_sn" @change="type = 'p'"></el-radio>
                <div class="item-content">
                  <div class="remark">
                    <p class="text-one">
                      <span v-for="(name) in item.user_attribute">
                        <attributeName :name="name" />
                        {{ item.type_name }}：{{ item.remark }}
                      </span>
                    </p>
                  </div>
                  <div class="NO"><router-link :to="'/generalInspectionListDetails?id=' + item.inspect_sn"
                      target="_blank">
                      {{ item.inspect_sn }}</router-link></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 添加精检单 -->
        <div class="list">
          <div class="type">
            <el-button type="primary" size="small" class="primary" @click="inspectStore(2)" v-if="isAuth(194)">
              {{ $t("message.addTheQualityCheckSheet") }}
            </el-button>
          </div>
          <div class="item" v-for="item in J_list" :key="item.inspect_sn">
            <div class="item-box">
              <el-radio v-model="radio" :label="item.inspect_sn" @change="type = 'J'"></el-radio>
              <div class="item-content">
                <div class="remark">
                  <p class="text-one">
                    {{ item.type_name }}：{{ item.remark }}
                  </p>
                </div>
                <div class="NO"> <router-link :to="'/generalInspectionListDetails?id=' + item.inspect_sn"
                    target="_blank">
                    {{ item.inspect_sn }}</router-link></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 操作 -->
      <div class="operation" v-if="isChecking">
        <!-- 全选 -->
        <el-checkbox v-model="checked" @change="allChecked">{{
          $t("message.allChecked")
        }}</el-checkbox>
        <!-- 复制订单商品信息 -->
        <el-button type="primary" size="small" class="primary" @click="copyOrderProductInformation">{{
          $t("message.copyOrderProductInformation") }}</el-button>
        <!-- 提出问题产品 -->
        <el-button type="success" size="small" class="primary" @click="askAQuestionAboutTheProduct"
          v-if="isAuth(171)">{{
            $t("message.askAQuestionAboutTheProduct") }}</el-button>
        <!-- 加入检品单 -->
        <el-button type="primary" size="small" @click="inspectStoreDetail" v-if="isAuth(196)">{{
          $t("message.addToInspectionList")
        }}</el-button>
        <!-- 标记特殊商品 -->
        <el-button type="success" size="small" @click="commodityMonitoringEntry">{{
          $t("message.markSpecialItems")
        }}</el-button>
        <!-- 上架入库 -->
        <el-button type="primary" size="small" class="primary" @click="putOnStoreShelves" v-if="isAuth(184)">{{
          $t("message.putOnStoreShelves") }}</el-button>
        <!-- 直接装箱 && authorized-->
        <el-button type="primary" size="small" class="primary" @click="directPacking" v-if="isAuth(189)">{{
          $t("message.directPacking")
        }}</el-button>
        <!-- 商品信息录入 -->
        <el-button size="mini" type="primary" class="secondary" @click="commodityInformationEntry(1)"
          v-if="isAuth(727)">
          {{ $t("message.productInformationEntry") }}
        </el-button>
        <!-- 商品重量录入 -->
        <el-button size="mini" type="primary" class="secondary" @click="commodityInformationEntry(5)"
          v-if="isAuth(742)">
          {{ $t("message.productWeightEntry") }}
        </el-button>
        <!-- 移库与“上架入库”共用权限点 184。 -->
        <el-button type="primary" size="small" class="moveLibraryButton" @click="openBatchMovePreview"
          v-if="isAuth(184)">
          {{ $t("message.moveTheLibrary") }}
        </el-button>
      </div>
    </div>
    <!-- 商品备注  -->
    <commodityNote :data="itemData" v-if="commodityNoteDialogVisible" />
    <!-- 批量移库明细：先按勾选的采购记录预览库存，再进入目标库位选择。 -->
    <batchMovePreview ref="batchMovePreview" @confirm="confirmBatchMove" />
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :up_data="up_data" :yiku_data="batchMoveList"
      :type="warehouseType" :shelf_type_set="[1, 3,]" :userid="userid"
      :order_purchase_ids="order_purchase_ids" :order_info="upStorageOrderList" />
    <!-- 问题产品 -->
    <problemStore />
    <!-- 包裹打印 -->
    <div v-show="false">
      <Printparcelinformation ref="Printparcelinformation" :datas="PrintparcelinformationData" v-if="show" />
    </div>
    <!-- 标签打印 -->
    <div v-show="false">
      <div v-if="printTagData != null" ref="tabPrint">
        <tabPrint :printTagData="printTagData" :isExpress="isExpress" />
      </div>
    </div>
    <!-- 打印用户信息 -->
    <div v-show="false">
      <Customerinformation ref="Customerinformation" :userData="userData" />
    </div>
    <!-- 特殊标签打印 -->
    <div v-show="false">
      <div v-if="specialLabelData != null" ref="specialLabelPrinting">
        <specialLabelPrinting :specialLabelData="specialLabelData" />
      </div>
    </div>
    <!-- 物流号选择 -->
    <el-dialog :title="$t('message.logisticsNumberSelection')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="320px" center>
      <div class="content">
        <el-select v-model="PrintparcelinformationData.express_no" placeholder="请选择" @change="$forceUpdate()">
          <el-option v-for="item in wuliuList" :key="item.express_no" :label="item.express_no" :value="item.express_no">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 打印 -->
        <el-button type="primary" @click="confirmUpStorageExpress" v-if="pendingPrintType == 'upStorageEntry'">{{
          $t("message.ok")
        }}</el-button>
        <!-- 打印 -->
        <el-button type="primary" @click="print" v-else-if="isPrintparcelinformation">{{
          $t("message.print")
        }}</el-button>
        <!-- 打印 -->
        <el-button type="primary" @click="itemPrintparcelinformatio" v-else>{{
          $t("message.print")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 查看备注 -->
    <el-dialog :title="'RK' + $t('message.orderNotes')" :close-on-click-modal="false"
      :visible.sync="remarkDialogVisible" width="900px">
      <el-table :data="remarkData" style="width: 100%" border :header-cell-style="{ background: '#F0F0F0 ' }">
        <!-- 业务备注 -->
        <el-table-column :label="$t('message.serviceOrderRemarks')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.y_remark" onfocus="this.select()" type="textarea" disabled></el-input>
            </div>
            <p>{{ scope.row.y_last_updated_at }}</p>
          </template>
        </el-table-column>
        <!-- 采购备注 -->
        <el-table-column :label="$t('message.purchaseOrderRemarks')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.g_remark" onfocus="this.select()" type="textarea" disabled></el-input>
            </div>
            <p>{{ scope.row.g_last_updated_at }}</p>
          </template>
        </el-table-column>
        <!--  配货订单备注-->
        <el-table-column :label="$t('message.fulfillmentOrderNotes')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.p_remark" disabled onfocus="this.select()" type="textarea"></el-input>
            </div>
            <p>{{ scope.row.p_last_updated_at }}</p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false" type="primary">{{
          $t("message.save")
        }}</el-button>
        <!-- <el-button type="primary" @click="updateSystemRemark">{{
          $t("message.save")
        }}</el-button> -->
      </span>
    </el-dialog>
    <!--加入检品单 提示 -->
    <el-dialog title="加入普检单提示" :close-on-click-modal="false" :visible.sync="PdialogVisible" width="600px" center>
      <div class="content">
        <div style="color:red;font-size:26px;">以上商品有部分精检，请不要全部数量加入检品单，请检查加入数量。 </div>
        <div style="color:red;font-size:26px;margin-bottom:8px" v-for="(item, index) in isJtoP" :key="index">
          {{ item.order_sn }}: {{ item.sorting }} </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="PdialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 打印 -->
        <el-button type="primary" @click="storeDetail">加入普检单</el-button>
      </span>
    </el-dialog>
    <!-- 检品状态详情 -->
    <inspectDetail ref="inspectDetail" :tableData="inspectDetailList" />
    <!-- 监控商品 -->
    <monitorProductSettings ref="monitorProductSettings" :checkedList="checkedList" />
    <!-- 直接装箱 -->
    <encasement :order_purchase_ids="order_purchase_ids" v-if="directPackingDialogVisible" />
    <!-- 注意事项 -->
    <getNotice ref="getNotice" />
    <!-- 单个打印包裹信息 -->
    <div v-show="false">
      <itemPrintparcelinformation ref="itemPrintparcelinformation" :datas="itemPrintparcelinformationData"
        v-if="itemShow" />
    </div>
    <!-- 送检数填写 -->
    <submitForInspectionLabel ref="submitForInspectionLabel" />
    <!-- 上架唛头打印 -->
    <putOnShelvesLabel ref="putOnShelvesLabel" />
    <!-- 退货唛头打印 -->
    <returnLabel ref="returnLabel" />
    <!-- 打标 -->
    <labeling12911 ref="labeling12911" />
    <!-- pint7x4positive -->
    <div v-show="false" v-if="isPrint7x4positive">
      <pint7x4positive ref="pint7x4positive" :printData="printData" />
    </div>
    <!-- pint7x4reverse -->
    <div v-show="false" v-if="isPrint7x4reverse">
      <pint7x4reverse ref="pint7x4reverse" :printData="printData" />
    </div>
    <!-- pint90x95 -->
    <div v-show="false" v-if="isPrint90x95">
      <pint90x95 ref="pint90x95" :printData="printData" />
    </div>
    <!-- 核查上架唛头打印 -->
    <div v-show="false" v-if="isCheckPutOnShelvesLabel">
      <checkPutOnShelvesLabel ref="checkPutOnShelvesLabel" :label-data="checkPutOnShelvesLabelData" />
    </div>
    <!-- 入库唛头打印 -->
    <div v-show="false" v-if="isUpStorageEntryLabel">
      <upStorageEntryLabel ref="upStorageEntryLabel" :label-data="upStorageEntryLabelData" />
    </div>
    <!-- 库位查看 -->
    <storageLocationProducts ref="storageLocationProducts" />
    <!-- 配送单预览 -->
    <deliveryPreview ref="deliveryPreview" />
    <!-- 业务录入时效预览 -->
    <businessPreview ref="businessPreview" />
    <!-- 不良品检品标签打印 -->
    <!-- <defectiveInspectionLabel ref="defectiveInspectionLabel" /> -->
  </div>
</template>
<script>
import detailHeader from "../../components/header/detailHeader";
import commodityNote from "../home/inspection/components/commodityNote";
import warehouse from "../../components/common/warehouse";
import problemStore from "@/components/problemStore/store/index.vue";
import Printparcelinformation from "@/components/Printedsheet/Printparcelinformation";
import Customerinformation from "@/components/Printedsheet/Customerinformation";
import inspectDetail from '../../components/box/inspectDetail'
import monitorProductSettings from '../orderDetail/components/monitorProductSettings'
import encasement from './encasement'
import tabPrint from '../../components/Printedsheet/tag/tabPrint'
import spotCheckDetails from '@/components/common/spotCheckDetails'
import specialLabelPrinting from '../../components/Printedsheet/tag/specialLabelPrinting'
import itemPrintparcelinformation from '@/components/Printedsheet/itemPrintparcelinformation'
import submitForInspectionLabel from './components/submitForInspectionLabel'
import putOnShelvesLabel from './components/putOnShelvesLabel'
import returnLabel from './components/returnLabel'
import labeling12911 from './components/labeling12911'
import pint7x4positive from "@/components/Printedsheet/tangji/pint7x4positive.vue"
import pint7x4reverse from "@/components/Printedsheet/tangji/pint7x4reverse.vue"
import pint90x95 from "@/components/Printedsheet/tangji/pint90x95.vue"
import checkPutOnShelvesLabel from '@/components/Printedsheet/checkPutOnShelvesLabel.vue'
import upStorageEntryLabel from '@/components/Printedsheet/upStorageEntryLabel.vue'
import { getDate } from '@/utlis/date'
import storageLocationProducts from './components/storageLocationProducts'
import batchMovePreview from './components/batchMovePreview'
import deliveryPreview from '../orderDetail/orderPaymentDetail/deliveryPreview.vue'
import businessPreview from '../orderDetail/orderPaymentDetail/businessPreview.vue'
import defectiveInspectionLabel from '@/components/Printedsheet/defectiveInspectionLabel.vue'
import MaterialInfo from '@/components/common/materialInfo'
import MaterialMarkTip from '@/components/common/materialMarkTip'
import { getPlanRemarkSnapshot, normalizePlanRemark, shouldExpandPlanRemark } from '@/utlis/materialRemark'
import { getAreaGridName } from '@/utlis/warehouseGrid'
export default {
  components: {
    submitForInspectionLabel,
    putOnShelvesLabel,
    detailHeader,
    commodityNote,
    warehouse,
    problemStore,
    Printparcelinformation,
    Customerinformation,
    inspectDetail,
    monitorProductSettings,
    encasement,
    tabPrint,
    spotCheckDetails,
    specialLabelPrinting,
    itemPrintparcelinformation,
    returnLabel,
    labeling12911,
    pint7x4positive,
    pint7x4reverse,
    pint90x95,
    checkPutOnShelvesLabel,
    upStorageEntryLabel,
    storageLocationProducts,
    batchMovePreview,
    deliveryPreview,
    businessPreview,
    defectiveInspectionLabel,
    MaterialInfo,
    MaterialMarkTip,
  },
  metaInfo() {
    return {
      title: this.isChecking ? '商品核查中' : '商品等待核查',
    };
  },
  data() {

    return {
      role: localStorage.getItem('japanUserRoleStatus'), //工种
      checked: true,
      tableData: [],
      planRemarkSaving: false,
      checkedList: [],
      radio: "",
      type: '',//添加的检品单类型
      commodityNoteDialogVisible: false, // 商品备注
      itemData: {}, //单番商品
      //   修改备注的索引
      index: {},
      isChecking: false, //是否可以操作
      warehouseDialogVisible: false, //仓库
      warehouseType: 1,//仓库组件操作类型
      up_data: [],
      batchMoveList: [], // 批量移库确认后提交给仓库组件的库存明细
      batchMovePrintOrder: null,//批量移库成功后复用上架规则打印入库唛头的订单
      upStorageOrderList: [],//本次上架勾选商品所属的订单信息
      P_list: [],
      J_list: [],
      PrintparcelinformationData: {
        express_no: ''
      }, //包裹打印信息
      show: false,
      itemShow: false,
      dialogVisible: false,
      isPrintparcelinformation: false,//是否打印包裹信息
      wuliuList: [],
      //打印用户信息
      userData: {},
      //PK订单备注
      remarkDialogVisible: false,
      remarkData: [],
      inspectDetailList: [],//检品单详情
      userRoleStatus: localStorage.getItem("japanUserRoleStatus"),
      itemDetail: {},//单个商品
      order_purchase_ids: [],//要装箱的商品
      directPackingDialogVisible: false,//直接装箱弹框
      printTagData: null,//标签
      specialLabelData: null,//特殊标签
      isExpress: '',
      authorized: false,// 是否授权
      userid: '',
      total: {
        possible_num: 0,
        storage_num: 0,
        totalPorderNum: 0
      },
      isJtoP: [],//有精检的加入普检的
      PdialogVisible: false,
      jData: {},
      itemPrintparcelinformationData: null,//单个打印包裹信息
      labelData: {},//1868标签数据
      printData: {},//唐吉打印标签数据
      isPrint7x4positive: false,
      isPrint7x4reverse: false,
      isPrint90x95: false,
      isCheckPutOnShelvesLabel: false,
      checkPutOnShelvesLabelData: {},
      isUpStorageEntryLabel: false,
      upStorageEntryLabelData: {},
      upStorageEntryOrder: null,//入库唛头打印的当前订单
      autoUpStorageEntryOrder: null,//上架完成后自动打印入库唛头的订单
      upStorageEntryGridInfo: null,//入库唛头打印使用的库位信息
      isAutoUpStorageEntryPrint: false,//是否为上架完成后的自动打印
      pendingPrintType: '',//待执行的打印类型
    };
  },
  computed: {
    isBusiness() {
      return Number(this.role) === 1
    },
    materialRows() {
      return this.tableData.reduce((rows, order) => rows.concat(order.list || []), [])
    },
    allMaterialsExpanded() {
      return this.materialRows.length > 0 && this.materialRows.every(item => item.materialExpanded)
    }
  },
  created() {
    this.upPreview();
  },
  methods: {
    // 订单商品的辅料标识详情由 material 返回
    isMaterial(item) {
      return Number(item.is_material) === 1 || Boolean(item.material_id) || Boolean(item.material && item.material.id)
    },
    // 核查详情只显示配货要求，按配货备注是否有值决定默认展开。
    initMaterialState(item) {
      this.$set(item, 'materialExpanded', shouldExpandPlanRemark(item, ['delivery'], this.isBusiness))
      this.$set(item, '_planRemarkSnapshot', getPlanRemarkSnapshot(item))
      this.$set(item, 'material_list', this.getOrderMaterialList(item))
    },
    getOrderMaterialList(item) {
      if (!Array.isArray(item.material_bind)) return []
      return item.material_bind.map(binding => {
        const material = binding.material_detail || binding.material || {}
        // 绑定记录 ID 不是辅料主档 ID，库位查询等操作只使用主档字段。
        const materialId = binding.material_id || material.id
        return {
          ...material,
          ...binding,
          id: materialId,
          material_id: materialId,
          type: material.type || binding.type || {},
          consume: binding.consume !== undefined && binding.consume !== null ? binding.consume : 1
        }
      })
    },
    // 库位仅显示“】-”后的实际编号。
    getStockGridNumber(gridNumber) {
      if (!gridNumber) return ''
      const separatorIndex = gridNumber.indexOf('】-')
      return separatorIndex === -1 ? gridNumber : gridNumber.slice(separatorIndex + 2)
    },
    toggleMaterial(item) {
      item.materialExpanded = !item.materialExpanded
    },
    toggleAllMaterials() {
      const expanded = !this.allMaterialsExpanded
      this.materialRows.forEach(item => {
        item.materialExpanded = expanded
      })
    },
    // 有勾选时批量保存当前要求；无勾选时仅保存当前商品，沿用业务编辑权限。
    async savePlanRemark(item, col) {
      if (!this.isBusiness || this.planRemarkSaving) return
      const remark = normalizePlanRemark(item[col])
      if (item._planRemarkSnapshot && item._planRemarkSnapshot[col] === remark) return

      const selectedList = this.materialRows.filter(row => row.checked)
      const list = selectedList.length ? selectedList : [item]
      if (!list.includes(item)) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
      }
      const changedList = list.filter(row => !row._planRemarkSnapshot || row._planRemarkSnapshot[col] !== remark)
      if (!changedList.length) return
      // 使用订单明细 ID 去重，一次请求完成批量修改。
      const orderDetailIds = [...new Set(changedList.map(row => row.order_detail_id))]

      this.planRemarkSaving = true
      try {
        const res = await this.$api.orderApi.updatePlanRemark({
          order_detail_id: orderDetailIds,
          col,
          remark,
        }, { isLoading: true, resolveError: true })
        if (res.code != 0 || res.success === false) {
          item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
          return
        }
        // 同一订单明细可能重复展示；成功后同步对应行，不改其他商品或要求。
        this.materialRows.filter(row => orderDetailIds.includes(row.order_detail_id)).forEach(row => {
          this.$set(row, col, remark)
          if (!row._planRemarkSnapshot) this.$set(row, '_planRemarkSnapshot', getPlanRemarkSnapshot(row))
          row._planRemarkSnapshot[col] = remark
          this.$set(row, 'materialExpanded', true)
        })
        this.$message.success(res.msg)
      } catch (error) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
        // 失败提示由公共请求层处理，未保存行保持原值。
      } finally {
        this.planRemarkSaving = false
      }
    },
    // 核查界面获取未提交检品的检品单列表
    inspectUnAllotList() {
      this.$api.inspectionApi.inspectUnAllotList().then((res) => {
        this.P_list = res.data.filter((item) => item.type == 1);
        this.J_list = res.data.filter((item) => item.type == 2);
      });
    },
    // 列表
    upPreview() {
      let datas = {
        purchase_no: this.$route.query.purchase_no,
        express_no: this.$route.query.express_no,
      };
      this.total = {
        possible_num: 0,
        storage_num: 0
      }
      let order_detail_id = this.$route.query.order_detail_id || ''//订单详情id
      return this.$api.inspectionApi.upPreview(datas).then((res) => {
        this.inspectUnAllotList();
        res.data.forEach((item) => {
          item.checked = true
          this.userid = item.user.id + ''
          this.$refs.getNotice.getNotice(this.userid, "配货注意事项")
          item.list.forEach((items) => {
            items.checked = true;
            items.order_sn = item.order_sn
            this.initMaterialState(items)
            this.total.possible_num += items.possible_num - 0
            this.total.storage_num += items.storage_num - 0

            // items.maxUpNum = items.maxUpNum
          });
          if (order_detail_id) {
            item.list = item.list.filter((items) => items.order_detail_id == order_detail_id)
          }
        });
        this.tableData = res.data;
        // 是否都处于开始核查的状态
        for (let i = 0; i < this.tableData.length; i++) {
          let flag = this.tableData[i].list.every((item) => item.status >= 40);
          if (!flag) break;
          this.isChecking = true;
        }
        // 是否当前配货员
        let is_belongs = this.tableData.every((item) => item.is_belongs);
        this.authorized = this.tableData.some((item) => item.user.authorized);
        this.allChecked()
        this.orderDetailTotalPorderNum()
        //  <!-- 抽查详细 -->
        this.getSpotOrderDetail()
        // if (!is_belongs) {
        //   this.$alert(
        //     "有商品对应配货员不是当前登录配货员！请确认后再操作",
        //     "注意！",
        //     {
        //       confirmButtonText: "确定",
        //       center: true,
        //     }
        //   );
        // }
        // 返回本次详情数据，供“上架完成检查”等后续流程复用，避免只请求不刷新。
        return res
      });
    },
    //核查-查询某些番总的提出到配送单的数量
    orderDetailTotalPorderNum() {
      let datas = {
        order_purchase_id_set: []
      }
      this.tableData.forEach(item => {
        item.list.forEach(items => {
          datas.order_purchase_id_set.push(items.order_purchase_id)
        })
      })
      this.$api.inspectionApi.orderDetailTotalPorderNum(datas).then(res => {
        this.total.totalPorderNum = res.data
        this.$forceUpdate()
      })
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.checked = item.list.every(items => items.checked)
        item.list.forEach((items) => {
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate();
    },
    //订单全选
    changeOrder() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = item.checked
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.checked = this.checked;
        item.list.forEach((items) => {
          items.checked = this.checked;
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    //取消全选
    cancelAllChecked() {
      this.checkedList = [];
      this.checked = false;
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = false;
        });
      });
      this.$forceUpdate();
    },
    // 复制订单商品信息
    copyOrderProductInformation() {
      let copyList = []
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            copyList.push(`注文番号：${item.order_sn}\n${items.sorting}番  ${items.origin_link}\n交易号: ${item.purchase_no}`)
          }
        });
      });
      if (copyList.length === 0) {
        return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"));
      }
      this.copy(copyList.join("\n\n"))
    },
    // 是否显示商品列表
    isShow(i) {
      this.tableData[i].show = !this.tableData[i].show;
      this.$forceUpdate();
    },
    // 最小数和最大数
    minMaxNum(i, is, item) {
      if (item.maxUpNum > item.possible_num - item.storage_num) {
        this.tableData[i].list[is].maxUpNum =
          item.possible_num - item.storage_num;
      }
      //   else if (item.stock_num - item.maxUpNum < 0) {
      //     this.tableData[i].list[is].maxUpNum = 0 - item.stock_num;
      //   }
      this.$forceUpdate();
    },
    //商品备注
    remarkAll(item, index, indexs) {
      console.log(item);
      this.index = {
        index,
        indexs,
      };
      this.itemData = item;
      this.commodityNoteDialogVisible = true;
    },
    //更新备注
    uploadRemark(data) {
      this.commodityNoteDialogVisible = false;
      if (data.remark_type == "Y") {
        this.tableData[this.index.index].list[this.index.indexs].y_remark =
          data.remark;
      } else if (data.remark_type == "G") {
        this.tableData[this.index.index].list[this.index.indexs].g_remark =
          data.remark;
      } else if (data.remark_type == "P") {
        this.tableData[this.index.index].list[this.index.indexs].p_remark =
          data.remark;
      }
    },
    //开始核查
    startChecking() {
      let data = {
        purchaseIds: [],
      };
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          data.purchaseIds.push(items.order_purchase_id);
        });
      });
      this.$api.inspectionApi.startChecking(data).then((res) => {
        this.$message.success(res.msg);
        this.isChecking = true;
        this.$forceUpdate();
      });
    },
    //直接装箱
    directPacking() {
      let data = this.set_order_purchase_id()
      // 不能为空
      if (data.data == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (data.list.length > 1) return this.$message.error("只能操作一个订单号");
      this.order_purchase_ids = data.data
      this.directPackingDialogVisible = true
      // let routeUrl = this.$router.resolve({
      //   path: `/encasement?purchase_no=${this.$route.query.purchase_no
      //     }&express_no=${this.$route.query.express_no
      //     }&order_purchase_ids=${}`,
      // });
      // window.open(routeUrl.href, JSON.stringify(data));
    },
    set_order_purchase_id() {
      let data = [];
      let list = [];
      this.tableData.forEach((item) => {
        let flag = item.list.some((items) => items.checked);
        if (flag) {
          list.push(item);
        }
        item.list.forEach((items) => {
          if (items.checked) {
            data.push(items.order_purchase_id);
          }
        });
      });
      return { data, list }
    },
    //上架入库
    putOnStoreShelves() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.up_data = [];
      this.checkedList.forEach((item) => {
        this.up_data.push({
          num: item.maxUpNum,
          order_purchase_id: item.order_purchase_id,
          uncomplete_problem_num: item.uncomplete_problem_num
        });
      });
      let data = this.set_order_purchase_id()
      // 不能为空
      if (data.data == false)
        return this.$message.error(this.$t("message.selectableOperational"));

      this.order_purchase_ids = data.data
      this.upStorageOrderList = data.list
      // 本次存在负数上架时，不触发上架完成后的自动唛头打印
      const hasNegativeUpStorage = this.up_data.some(item => Number(item.num) < 0)
      this.autoUpStorageEntryOrder = hasNegativeUpStorage ? null : this.getAutoUpStorageEntryOrder(data.list)
      this.warehouseType = 1
      this.warehouseDialogVisible = true;
    },
    /**
     * 根据核查列表当前勾选项打开批量移库明细。
     * 这里只传采购记录 ID，库存与库位信息统一由预览接口返回。
     */
    openBatchMovePreview() {
      if (this.checkedList == false) {
        return this.$message.error(this.$t("message.selectableOperational"));
      }
      const orderPurchaseIds = Array.from(new Set(this.checkedList.map(item => item.order_purchase_id)))
      this.$refs.batchMovePreview.open(orderPurchaseIds)
    },
    // 移库明细确认后，仅保留弹窗勾选番并打开仓库组件选择目标库位。
    confirmBatchMove(list, orderPurchaseIds) {
      const selectedIdSet = new Set((orderPurchaseIds || []).map(id => String(id)))
      const orderList = this.tableData.filter((order) => {
        return (order.list || []).some(item => selectedIdSet.has(String(item.order_purchase_id)))
      })
      this.batchMoveList = list
      this.batchMovePrintOrder = this.getAutoUpStorageEntryOrder(orderList)
      // 移库选择目标库位时复用上架订单信息栏，展示付款、交易号、物流号及人员信息。
      this.upStorageOrderList = orderList
      this.order_purchase_ids = orderPurchaseIds || []
      this.warehouseType = 14
      this.warehouseDialogVisible = true
    },
    /**
     * 选择新库位后提交批量移库；成功后复用上架的物流号选择和入库唛头打印流程。
     */
    submitBatchMove(targetGridId, gridNumber, gridItem = {}, shelves = {}, shelfLayer = {}) {
      const printOrder = this.batchMovePrintOrder
      return this.$api.followApi.batchMove({
        target_grid_id: String(targetGridId),
        list: this.batchMoveList,
      }).then((res) => {
        this.$message.success(res.msg)
        // 移库实际完成后再关闭明细，选库取消或接口失败时继续保留已填写内容。
        if (this.$refs.batchMovePreview) this.$refs.batchMovePreview.close()
        this.batchMoveList = []
        this.batchMovePrintOrder = null
        this.order_purchase_ids = []
        this.warehouseType = 1
        this.upPreview()
        if (printOrder) {
          this.startUpStorageEntryLabelPrint(printOrder, {
            gridNumber,
            gridItem,
            shelves,
            shelfLayer,
          })
        }
        return res
      })
    },
    // 目标库位移库成功后刷新核查页库存数据。
    stockMoveSuccess() {
      this.warehouseDialogVisible = false
      this.warehouseType = 1
      this.upPreview()
    },
    //创建检品单
    inspectStore(type) {
      this.$api.inspectionApi.inspectStore({ type }).then((res) => {
        this.$message.success(res.msg);
        this.inspectUnAllotList();
      });
    },
    //添加商品到检品单
    inspectStoreDetail() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (this.radio == "") return this.$message.error("请选择检品单");
      let datas = {
        inspect_sn: this.radio,
        data: [],
      };
      this.isJtoP = []
      this.checkedList.forEach((item) => {
        datas.data.push({
          num: item.maxUpNum,
          order_purchase_id: item.order_purchase_id,
          option: item.option,
          sorting: item.sorting,
          order_sn: item.order_sn,

        });
      });
      if (this.type == 'J') {
        for (let i = 0; i < datas.data.length; i++) {
          if (datas.data[i].option) {
            let flag = datas.data[i].option.some(item => item.name.indexOf('详细检品') != -1 || item.name == '有料検品' || item.name == '詳細検品' || item.name == '詳細檢品' || item.name == '详细検品')

            if (!flag) {
              return this.$message.error("番号" + datas.data[i].sorting + '没有详细检品，不能添加精检单 ')
            }
          }
        }
      }
      else {
        for (let i = 0; i < datas.data.length; i++) {
          if (datas.data[i].option) {
            let flag = datas.data[i].option.some(item => item.name.indexOf('详细检品') != -1 || item.name == '有料検品' || item.name == '詳細検品' || item.name == '詳細檢品' || item.name == '详细検品')
            if (flag) {
              this.isJtoP.push({
                order_sn: datas.data[i].order_sn,
                sorting: datas.data[i].sorting,
              })
            }
          }
        }
      }
      this.jData = datas
      // 判断是否精简
      if (this.isJtoP != false && this.type == 'p') {
        this.PdialogVisible = true
      } else {
        this.storeDetail()
      }
    },
    // 加入检品单
    storeDetail() {
      this.$api.inspectionApi.inspectStoreDetail(this.jData).then((res) => {
        if (res.code == 10006) {
          this.skipSpotCheck(res.msg)
          return false
        }
        this.$message.success(res.msg);
        this.upPreview();
        this.radio = "";
        this.PdialogVisible = false
      });
    },
    // 跳过抽查
    skipSpotCheck(msg) {
      this.$confirm(
        msg,
        this.$t("message.hint"),
        {
          confirmButtonText: '继续操作', //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.jData.reconfirm = 1
          this.$api.inspectionApi.inspectStoreDetail(this.jData).then((res) => {
            this.$message.success(res.msg);
            this.jData.reconfirm = ''
            this.upPreview();
            this.radio = "";
            this.PdialogVisible = false
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //pk查看
    lookRemark(item) {
      this.remarkData[0] = item
      this.remarkDialogVisible = true
    },
    //问题产品
    askAQuestionAboutTheProduct() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        order_purchase_id: [],
        inspect_bad_id: [],
        status: [],
      };
      let order_sn = [];
      this.checkedList.forEach((item) => {
        datas.order_purchase_id.push(item.order_purchase_id);
        order_sn.push(item.order_sn);
      });

      //
      if (datas.order_purchase_id == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      order_sn = Array.from(new Set(order_sn));
      // 问题产品提出需要限制单次只能单个订单的商品一起提出问题产品
      if (order_sn.length > 1)
        return this.$message.error(this.$t("message.danGeDanDingDan"));
      this.$store.dispatch("getProblemList", datas);
    },
    // 问题产品提交成功
    problemStoreSuccess() {
      this.upPreview();
      this.checked = false;
    },
    // 上架完成后自动执行入库唛头打印
    afterFollowUpStorage(gridNumber, gridItem = {}, shelves = {}, shelfLayer = {}) {
      if (!this.autoUpStorageEntryOrder) {
        this.isAllUpStorage()
        return
      }
      this.startUpStorageEntryLabelPrint(this.autoUpStorageEntryOrder, {
        gridNumber,
        gridItem,
        shelves,
        shelfLayer
      }, true)
      this.autoUpStorageEntryOrder = null
    },
    // 从本次上架勾选的订单中确定入库唛头打印数据
    getAutoUpStorageEntryOrder(orderList = []) {
      const list = orderList.filter(Boolean)
      if (list == false) return null
      const firstOrder = list[0]
      const firstUserId = firstOrder.user ? firstOrder.user.id : ''
      const firstExpressText = this.getUpStorageExpressList(firstOrder).map(item => item.express_no).join(',')
      const isSamePrintTarget = list.every((item) => {
        const userId = item.user ? item.user.id : ''
        const expressText = this.getUpStorageExpressList(item).map(express => express.express_no).join(',')
        return userId == firstUserId && expressText == firstExpressText
      })
      return isSamePrintTarget ? firstOrder : null
    },
    // 打开仓库组件选择打印库位
    openPrintLocationDialog(type) {
      this.pendingPrintType = type
      this.warehouseType = 13
      this.up_data = []
      this.order_purchase_ids = []
      this.warehouseDialogVisible = true
    },
    // 仓库组件选择库位后继续执行原打印流程
    selectChargeGridNumber(gridNumber, gridItem = {}, shelves = {}, shelfLayer = {}) {
      if (this.pendingPrintType == 'package') {
        this.PrintparcelinformationData.grid_number = gridNumber
        this.continuePrintPackageInformation()
      } else if (this.pendingPrintType == 'item') {
        this.itemPrintparcelinformationData.grid_number = gridNumber
        this.continueLabelPrinting()
      } else if (this.pendingPrintType == 'upStorageEntry') {
        this.generateUpStorageEntryLabel(gridNumber, gridItem, shelves, shelfLayer)
      }
      this.pendingPrintType = ''
      this.warehouseType = 1
    },
    // 点击入库唛头打印，根据物流号数量决定是否先弹出物流号选择框
    printUpStorageEntryLabel(item) {
      this.startUpStorageEntryLabelPrint(item)
    },
    // 入库唛头打印入口：手动打印需要选库位，自动打印复用本次上架库位
    startUpStorageEntryLabelPrint(item, gridInfo = null, isAutoPrint = false) {
      const expressList = this.getUpStorageExpressList(item)
      if (expressList == false) {
        if (isAutoPrint) this.isAllUpStorage()
        return this.$message.error('暂无物流号')
      }
      this.upStorageEntryOrder = item
      this.upStorageEntryGridInfo = gridInfo
      this.isAutoUpStorageEntryPrint = isAutoPrint
      this.PrintparcelinformationData.express_no = ''
      if (expressList.length > 1) {
        this.wuliuList = expressList
        this.pendingPrintType = 'upStorageEntry'
        this.dialogVisible = true
        this.$forceUpdate()
        return
      }
      this.PrintparcelinformationData.express_no = expressList[0].express_no
      this.continueUpStorageEntryLabel()
    },
    // 取当前订单有效物流号
    getUpStorageExpressList(item = {}) {
      return Array.isArray(item.order_purchase_express)
        ? item.order_purchase_express.filter(express => express && express.express_no)
        : []
    },
    // 多个物流号时确认当前要打印入库唛头的物流号
    confirmUpStorageExpress() {
      if (!this.PrintparcelinformationData.express_no) return this.$message.error('请选择物流号')
      this.dialogVisible = false
      this.continueUpStorageEntryLabel()
    },
    // 物流号确定后继续入库唛头打印流程
    continueUpStorageEntryLabel() {
      if (this.upStorageEntryGridInfo) {
        const { gridNumber, gridItem, shelves, shelfLayer } = this.upStorageEntryGridInfo
        this.pendingPrintType = ''
        this.generateUpStorageEntryLabel(gridNumber, gridItem, shelves, shelfLayer)
        return
      }
      this.openUpStorageEntryWarehouse()
    },
    // 打开仓库组件选择入库唛头需要打印的库位
    openUpStorageEntryWarehouse() {
      this.pendingPrintType = 'upStorageEntry'
      this.warehouseType = 13
      this.up_data = []
      this.order_purchase_ids = []
      this.warehouseDialogVisible = true
    },
    // 选择库位后获取入库码，并组装入库唛头打印数据
    generateUpStorageEntryLabel(gridNumber, gridItem = {}, shelves = {}, shelfLayer = {}) {
      const item = this.upStorageEntryOrder || {}
      const user = item.user || {}
      const expressNo = this.PrintparcelinformationData.express_no
      if (!user.id || !expressNo) return this.$message.error('入库唛头打印数据不完整')
      this.$api.followApi.generateUpStorageEntryCode({
        user_id: user.id,
        express_no: expressNo
      }).then((res) => {
        const entryData = res.data || {}
        this.upStorageEntryLabelData = {
          print_date: getDate().split(' ')[0],
          customer_level: this.getCustomerLevel(item.user_attribute),
          customer_info: this.getCustomerInfoText(item),
          entry_no: this.getUpStorageEntryNo(entryData.seq, user.id),
          grid_text: this.getGridPrintText(gridNumber, gridItem, shelves, shelfLayer),
          entry_code: entryData.entry_code || '',
          salesman_name: item.y_name || '',
          purchaser_name: item.g_name || '',
          printer_name: this.getCurrentAdminName()
        }
        this.printUpStorageEntry()
      })
    },
    // 根据接口返回的seq生成入库码，seq小于10时补0
    getUpStorageEntryNo(seq, userId) {
      if (seq === '' || seq === undefined || seq === null) return `-${userId || ''}`
      const seqText = String(seq).padStart(2, '0')
      return `${seqText}-${userId || ''}`
    },
    // 组装客户信息：客户名+客户ID
    getCustomerInfoText(item) {
      const user = item.user || {}
      return `${user.realname || ''}-${user.id || ''}`
    },
    // 提取客户等级，用于唛头右上角展示
    getCustomerLevel(userAttribute) {
      const attributeText = this.getUserAttributeText(userAttribute)
      if (!attributeText) return ''
      return attributeText.split('、')[0]
    },
    // 兼容字符串、数组、对象数组等客户属性格式，转换成可打印文本
    getUserAttributeText(userAttribute) {
      if (!userAttribute) return ''
      if (typeof userAttribute == 'string') return userAttribute
      if (Array.isArray(userAttribute)) {
        return userAttribute.map((item) => {
          if (typeof item == 'string') return item
          return item.name || item.value || item.label || ''
        }).filter(Boolean).join('、')
      }
      return userAttribute.name || userAttribute.value || userAttribute.label || ''
    },
    // 入库唛头库位与库位管理打印规则一致：区域用途编码 + “】-”后的完整库位编号。
    getGridPrintText(gridNumber, gridItem = {}, shelves = {}) {
      const fullGridNumber = gridNumber || gridItem.grid_number || ''
      return getAreaGridName(shelves.area_type_code, fullGridNumber)
    },
    // 获取当前登录账号真名，用于入库唛头打印人
    getCurrentAdminName() {
      const adminInfo = localStorage.getItem('japanUserRoleInfo')
      if (!adminInfo) return ''
      try {
        return JSON.parse(adminInfo).realname || ''
      } catch (e) {
        return ''
      }
    },
    // 渲染入库唛头条码后调用打印
    printUpStorageEntry() {
      this.isUpStorageEntryLabel = true
      this.$nextTick(() => {
        const labelRef = this.$refs.upStorageEntryLabel
        if (labelRef) {
          labelRef.createBarcode()
        }
        this.$nextTick(() => {
          this.$print(labelRef)
          this.isUpStorageEntryLabel = false
          this.upStorageEntryOrder = null
          this.upStorageEntryGridInfo = null
          if (this.isAutoUpStorageEntryPrint) {
            this.isAutoUpStorageEntryPrint = false
            this.isAllUpStorage()
          }
        })
      })
    },
    //打印包裹信息
    printPackageInformation(item) {
      this.show = false;
      const { grid_number, ...printData } = item
      this.PrintparcelinformationData = printData;
      this.continuePrintPackageInformation()
    },
    // 打印整单包裹信息
    continuePrintPackageInformation() {
      const item = this.PrintparcelinformationData
      const expressList = item.order_purchase_express != false ? item.order_purchase_express : []
      if (expressList.length > 1) {
        this.wuliuList = expressList
        this.dialogVisible = true
        this.isPrintparcelinformation = true
        this.$forceUpdate()
      } else {
        this.PrintparcelinformationData.express_no = expressList.length ? expressList[0].express_no : ''
        this.print()
      }
    },
    //打印
    print() {
      this.show = true;
      this.$nextTick(() => {
        this.$print(this.$refs.Printparcelinformation);
        this.show = false;
        this.dialogVisible = false
      }, 500);
    },
    //打印客户信息
    printCustomerInformation(item) {
      this.userData = item.user
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$print(this.$refs.Customerinformation);
      });
    },
    //查看检品详情
    lookInspect(item) {
      this.inspectDetailList = item.inspect_detail
      this.$refs.inspectDetail.dialogVisible = true
    },
    //修改备注
    updateOrderDetailRemark(item, remark, type) {
      let datas = {
        remark: remark,
        remark_type: type,
        order_detail_id: item.order_detail_id
      }
      this.$api.inspectionApi
        .updateOrderDetailRemark(datas)
    },
    //商品监控
    commodityMonitoringEntry() {
      this.$refs.monitorProductSettings.dialogVisible = true

    },
    //标签打印
    printTag(item, type) {
      if (item.order_detail_tag != false) {
        this.printTagData = item.order_detail_tag[0]
        this.isExpress = type

        this.$nextTick(() => {
          this.$print(this.$refs.tabPrint);
          this.printTagData = null
        });
      }

    },
    // 查询是否上架完毕
    isAllUpStorage() {
      // 复用详情刷新方法：既更新页面数据，也使用同一次响应判断是否全部上架完毕。
      return this.upPreview().then((res) => {
        let flagList = []
        res.data.forEach((item) => {
          item.list.forEach((items) => {
            if (items.possible_num == items.storage_num) {
              flagList.push(true)
            } else {
              flagList.push(false)
            }
          });
        });
        let flag = flagList.every(item => item)
        console.log(flagList);
        if (flag) {
          setTimeout(() => {
            window.open("about:blank", "_top").close();
          }, 1000)
        }
      });
    },
    //抽查任务查询
    getSpotOrderDetail() {
      let datas = {
        order_purchase_id_set: [],
      }
      this.tableData.forEach(item => {
        item.list.forEach(items => {
          datas.order_purchase_id_set.push(items.order_purchase_id)
        })
      })
      this.$api.spotCheckApi.getSpotUpstorageDetail(datas).then(res => {
        let spotList = res.data
        this.tableData.forEach(item => {
          item.list.forEach(items => {
            for (let key in spotList) {
              if (items.order_purchase_id == key && spotList[key] != false) {
                items.spotDetail = spotList[key]
                this.$forceUpdate()
              }
            }
          })
        })
      })
    },
    // 特殊标签打印
    specialLabelPrinting(item) {
      this.specialLabelData = {
        client_remark: item.client_remark
      }
      this.$nextTick(() => {
        this.$print(this.$refs.specialLabelPrinting);
        this.specialLabelData = null
      });
    },
    // 单个打印包裹信息
    labelPrinting(item, items) {
      const { grid_number, ...printData } = item
      this.itemPrintparcelinformationData = {
        ...printData,
        sorting: items.sorting,
        detail_y: items.detail_y
      }
      this.continueLabelPrinting()
    },
    // 打印单个包裹信息
    continueLabelPrinting() {
      const item = this.itemPrintparcelinformationData
      const expressList = item.order_purchase_express != false ? item.order_purchase_express : []
      if (expressList.length > 1) {
        this.wuliuList = expressList
        this.PrintparcelinformationData.express_no = ''
        this.dialogVisible = true
        this.isPrintparcelinformation = false
        this.$forceUpdate()
      } else {
        this.itemPrintparcelinformationData.express_no = expressList.length ? expressList[0].express_no : ''
        this.itemPrintparcelinformatio()
      }

    },
    // 打印包裹信息
    itemPrintparcelinformatio() {
      this.itemShow = true;
      this.$forceUpdate()
      if (this.PrintparcelinformationData.express_no) {
        this.itemPrintparcelinformationData.express_no = this.PrintparcelinformationData.express_no
      }
      this.$nextTick(() => {
        this.$print(this.$refs.itemPrintparcelinformation);
        this.dialogVisible = false
        this.itemShow = false;
      });
    },
    // 1868标签打印
    label1868Print(item, items, labelType) {
      let labelData = {
        sorting: items.sorting,
        detail_y: items.detail_y,
        order_sn: items.order_sn,
        order_detail_tag: items.order_detail_tag != false ? items.order_detail_tag[0] : '',
        confirm_num: items.confirm_num,
        inspectNum: '',
        type: '',
        g_name: item.g_name,
        p_name: item.p_name,
        y_name: item.y_name,
        user_name: item.user.realname,
        purchase_no: item.purchase_no,
        order_purchase_express: item.order_purchase_express != false ? item.order_purchase_express[0].express_no : '',
        inspect_detail: items.inspect_detail,
        inspect_sn: '',
        j_name: '',
      }
      if (items.order_detail_tag == '') {
        return this.$message.error(
          '请选择有标的商品'
        );
      }
      // 取detail_y的第一个值
      let type = items.detail_y != false ? items.detail_y[0].value : ''
      if (type.includes('／')) {
        labelData.type = type.split('／')[0]
      }
      // 没有检测类型时，取detail_y的第一个值
      if (labelData.type == '') {
        type = items.detail_y != false ? items.detail_y[1].value : ''
        if (type.includes('／')) {
          labelData.type = type.split('／')[0]
        }
      }
      // 检品标签打印
      if (labelType == 'inspection') {
        this.$refs.submitForInspectionLabel.labelData = labelData
        this.$refs.submitForInspectionLabel.dialogVisible = true
      }
      // 退货标签打印
      if (labelType == 'returnLabel') {
        this.$refs.returnLabel.labelData = labelData
        this.$refs.returnLabel.dialogVisible = true
      }
      if (labelType == 'putOnShelves') {
        if (items.inspect_detail == false) {
          this.$message.error('未加入检品单')
          return
        }
        labelData.inspect_detail.forEach(item => {
          item.checked = false
        })
        this.$refs.putOnShelvesLabel.labelData = labelData
        this.$refs.putOnShelvesLabel.dialogVisible = true
      }
    },
    // 打标
    labeling(item) {
      this.$refs.labeling12911.labelData = {
        sorting: item.sorting,
        order_sn: item.order_sn,
      }
      this.$refs.labeling12911.labeling()
    },
    // 核查上架唛头打印
    checkPutOnShelvesPrint(item, items) {
      const tag = items.order_detail_tag != false && items.order_detail_tag.length ? items.order_detail_tag[0] : {}
      const detailList = items.detail_y != false ? items.detail_y : []
      let gridNumber = items.grid_number || ''
      let typeVal = detailList[0] ? detailList[0].value : ''
      if (!gridNumber && typeVal.includes('／')) {
        gridNumber = typeVal.split('／')[0]
      }
      if (!gridNumber && detailList[1]) {
        typeVal = detailList[1].value
        if (typeVal.includes('／')) {
          gridNumber = typeVal.split('／')[0]
        }
      }
      const attribute = detailList.map(d => `${d.key}:${d.value}`).join(' ')
      let inspectorName = ''
      if (items.inspect_detail != false && items.inspect_detail.length) {
        const checked = items.inspect_detail.find(i => i.checked)
        inspectorName = checked ? checked.j_name : items.inspect_detail[0].j_name
      }
      this.checkPutOnShelvesLabelData = {
        print_date: getDate(),
        level: tag.type_translate || tag.type || '',
        user_name: item.user ? item.user.realname : '',
        grid_number: gridNumber,
        product_code: items.goods_no || items.goods_code || items.sorting,
        order_sn: items.order_sn,
        sorting: items.sorting,
        attribute,
        checker_name: item.p_name || '',
        purchaser_name: item.g_name || '',
        salesman_name: item.y_name || '',
        inspector_name: inspectorName,
      }
      this.isCheckPutOnShelvesLabel = true
      this.$nextTick(() => {
        const labelRef = this.$refs.checkPutOnShelvesLabel
        if (labelRef) {
          labelRef.createBarcode()
        }
        this.$nextTick(() => {
          this.$print(labelRef)
          this.isCheckPutOnShelvesLabel = false
        })
      })
    },
    // 唐吉坷德打印标签
    TJKDprintLabel(item, type) {

      let datas = {
        order_sn: item.order_sn,
        order_detail_id: item.order_detail_id,
      }
      this.$api.orderApi
        .bulkExcelResult(datas)
        .then((res) => {
          if (res.data == false) return this.$message.error('打印标签数据为空，请上传标签文件')
          let content = res.data[0].content
          content.material = content.material.replace(/\n/g, '<br>')
          content.company = content.company.replace(/\n/g, '<br>')
          content.desc = content.desc.replace(/\n/g, '<br>')
          this.printData = content
          // 打印7x4positive
          if (type == 'pint7x4positive') {
            this.isPrint7x4positive = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint7x4positive);
              this.isPrint7x4positive = false
            }, 500)
          }
          // 打印7x4positive
          if (type == 'print7x4reverse') {
            this.isPrint7x4reverse = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint7x4reverse);
              this.isPrint7x4reverse = false
            }, 500)
          }

          if (type == 'pint9x95positive') {
            this.isPrint90x95 = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint90x95);
              this.isPrint90x95 = false
            }, 500)
          }
        })
    },
    // 库位查看
    stockListCharge(order_purchase_id) {
      this.$refs.storageLocationProducts.stockListCharge(order_purchase_id)
    },
    // 商品信息录入（role：1 商品信息录入，5 商品重量录入）
    commodityInformationEntry(role) {
      let selectedList = []
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            let itemData = JSON.parse(JSON.stringify(items))
            itemData.id = items.order_detail_id
            itemData.delivery_total = items.stock_num
            itemData.storage_num_total = items.storage_num
            itemData.possible_num_total = items.possible_num
            selectedList.push(itemData)
          }
        });
      });
      if (selectedList == false) return this.$message.error(this.$t('message.selectableOperationalList'))
      if (role == '1') {
        this.$refs.businessPreview.datas = {
          order_detail_ids: selectedList.map(item => item.order_detail_id)
        }
        this.$refs.businessPreview.selectedList = selectedList
        this.$refs.businessPreview.businessPreview()
      } else if (role == '5') {
        this.$refs.deliveryPreview.datas = {
          order_detail_ids: selectedList.map(item => item.order_detail_id)
        }
        this.$refs.deliveryPreview.selectedList = selectedList
        this.$refs.deliveryPreview.deliveryPreview()
      }
    },
    // 商品信息录入刷新
    refresh() {
      this.upPreview()
    }
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.detail {
  min-width: 1910px;

  .inspectDetail {
    background: #f8f8f8;
    border-radius: 0px 8px 8px 8px;
    padding: 24px;
    margin: 24px;

    .inspectActions {
      display: flex;
      align-items: center;

      .materialBatchToggle {
        margin-left: auto;
      }
    }
  }
}

.table {
  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;
    margin: 20px 0;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;
      color: #000;

      .inspect_status {
        color: #2C96E7;
        cursor: pointer;
      }

      .inspectStatusCell {
        display: flex;
        min-height: 100%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .stockGridList {
        margin-top: 10px;
        color: #409eff;
        text-align: center;

        p {
          margin: 0 0 5px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .template {
        text-align: left;
        width: 100%;
        overflow-y: auto;
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
      }

      .contraband {
        position: absolute;
        top: -10px;
        right: -10px;

        img {
          width: 30px;
          height: 30px;
        }
      }



    }

    .fixedRight {
      position: sticky;
      right: 0px;
      background-color: #fff;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }


  }

  .flex15 {
    flex: 1.3;
  }

  .y_remark {
    /deep/.el-textarea__inner {
      color: red;
    }
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .itemDetail {
    .inspectGoodsGroup {
      position: relative;
    }

    .materialMarkTip {
      position: absolute;
      top: auto;
      // 辅料标识固定在番号单元格左下角，与订单详情页保持一致
      bottom: -8px;
      left: 0;
      z-index: 2;
    }

    // 选择列：复选框与展开按钮上下排列，展开固定最左下方
    .selectCell {
      flex-direction: column;
      justify-content: flex-start;
      gap: 10px;
      padding-bottom: 28px;
    }

    // 与订单详情 materialToggle 样式保持一致
    .materialToggle {
      position: absolute;
      left: 0;
      bottom: -8px;
      min-width: 56px;
      height: 24px;
      padding: 0 6px;
      border: 0;
      border-radius: 4px;
      color: #606266;
      background-color: #ecf5ff;
      color: #409eff;
   

      i {
        margin-left: 2px;
        font-size: 12px;
      }
    }

    // 两侧等宽，辅料卡片只在左侧横向滚动。
    .materialRequirements {
      display: flex;
      gap: 24px;
      min-width: 0;
      padding: 16px 20px;
      border-bottom: 1px solid #edeff4;
      background-color: #fff;
      box-sizing: border-box;
    }

    .materialRequirementsList,
    .materialRequirementsRemark {
      flex: 1 1 0;
      min-width: 0;
    }

    .materialRequirementsList {
      /deep/ .material-info-panel {
        padding: 0;
        border: 0;
      }

      /deep/ .material-list {
        display: flex;
        overflow-x: auto;
        padding: 10px 10px 8px 0;
      }

      /deep/ .material-card {
        flex: 0 0 288px;
      }

      /deep/ .empty {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 136px;
        padding: 0;
      }
    }

    .materialRequirementsRemark,
    .requirementItem {
      display: flex;
      flex-direction: column;
    }

    .requirementItem {
      flex: 1;
      min-width: 0;

      label {
        display: block;
        margin-bottom: 10px;
        color: #333;
        font-size: 14px;
        font-weight: bold;
      }

      /deep/ .el-textarea {
        display: flex;
        flex: 1;
      }

      /deep/ .el-textarea__inner {
        flex: 1;
        min-height: 96px;
        height: auto;
      }
    }

    .head {
      height: 60px;
      display: flex;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      a {
        color: #f0ef70;
      }

      .show {
        flex: 0.3;
        cursor: pointer;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 16px;
        }
      }

      .checkbox {
        flex: 0.3;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .item {
        flex: 1;
        line-height: 20px;
        padding: 10px;

        span {
          margin-right: 20px;
        }
      }

      .order {
        flex: 1.9;
      }

      .flex15 {
        flex: 1.5
      }

      .name {
        flex: 2;
        line-height: 40px;
      }

      .express_no-list {
        width: 20px;
        height: 20px;
        padding: 0;
        margin-left: 10px;

        /deep/.el-popper {
          background-color: pink !important;
        }
      }

      .lookRemark {
        flex: 2.5;
        text-align: right;
        line-height: 40px;
        margin-right: 14px;

      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

.addInspect {
  padding: 0 24px;
  background-color: #fff;

  .list {
    border-bottom: 1px solid #edeff4;
    display: flex;
    flex-wrap: wrap;

    &:nth-last-child(1) {
      border: 0;
    }

    .type {
      display: flex;
      align-items: center;
      width: 120px;
      border-right: 1px solid #edeff4;
    }

    .items {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
    }

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 296px;
      border-right: 1px solid #edeff4;
      padding: 24px 0;

      .item-box {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-radio__input {
          transform: scale(1.5);
        }

        /deep/ .el-radio__label {
          display: none;
        }

        .el-radio {
          margin-right: 10px;
        }

        .item-content {
          padding: 15px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          width: 178px;

          .remark {
            margin-bottom: 14px;
          }

          .NO {
            color: #999;
          }
        }
      }
    }
  }
}

.operation {
  background-color: #edeff4;
  padding: 16px 24px;
  position: sticky;
  bottom: 0;
  z-index: 9;

  .el-button {
    margin-left: 30px;
  }

  // 移库按钮单独靠右，其他操作按钮的排列保持不变。
  .moveLibraryButton {
    float: right;
  }

  span {
    margin-left: 30px;
    font-size: 14px;
    cursor: pointer;
  }
}

.content {
  padding: 20px;
}

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff;
    color: #606266;
  }
}

/deep/.el-textarea__inner {
  height: 100px;
  padding: 0;
}

.Controls {
  p {
    margin-bottom: 10px;
  }


}

.authorized {
  color: rgb(180, 39, 45);
  font-size: 40px;
  vertical-align: middle;
  margin-left: 30px;
}

.inspectNum {
  color: #B4272D !important;
  font-weight: bold;
  font-size: 20px;
}

.bigSize {
  font-size: 20px;
}

.order_remark {
  display: flex;
  margin: 24px 0;

  span {
    min-width: 50px;
  }
}

.total {
  font-size: 25px;
  font-weight: bold;
  color: #B4272D;
  padding-left: 500px;
  margin: 20px 0;

  span {
    margin-left: 100px;
  }
}
</style>
